import { render, staticRenderFns } from "./SiteViewStatistic.vue?vue&type=template&id=00ed218a&"
import script from "./SiteViewStatistic.vue?vue&type=script&lang=js&"
export * from "./SiteViewStatistic.vue?vue&type=script&lang=js&"
import style0 from "./SiteViewStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/statistics/SiteViewStatistic.vue
// module id = null
// module chunks = 